export default __webpack_public_path__ + "static/media/mallory_compact_bold.43cf256e.ttf";